<template>
  <div class="resister-content">
    <div class="mine-header"><span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png" /></span>{{ currentTitle }}</div>
    <div class="box">
      <ul v-if="fieldKey == 'login'">
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye"><img :src="fristeyepic" /></div>
          <input :type="fristtype" v-model="password" placeholder="Enter your old login password" />
        </li>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye1"><img :src="fristeyepic1" /></div>
          <input :type="fristtype1" v-model="password1" placeholder="Enter your new login password" />
        </li>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye2"><img :src="fristeyepic2" /></div>
          <input :type="fristtype2" v-model="password2" placeholder="Enter new login password again" />
        </li>
        <li>
          <button class="btn-submit" v-show="!showloding" @click="submitbtn">OK</button>
          <button class="btn-submit" v-show="showloding">OK</button>
        </li>
      </ul>
      <ul v-if="fieldKey == 'pay'">
        <li v-show="userInfo.has_pay_password == 1">
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye"><img :src="fristeyepic" /></div>
          <input :type="fristtype" v-model="password" placeholder="Enter your old fund password" />
        </li>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye1"><img :src="fristeyepic1" /></div>
          <input :type="fristtype1" v-model="password1" placeholder="Enter your new fund password" />
        </li>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye2"><img :src="fristeyepic2" /></div>
          <input :type="fristtype2" v-model="password2" placeholder="Enter new fund password again" />
        </li>
        <li>
          <button class="btn-submit" v-show="!showloding" @click="submitbtn2">OK</button>
          <button class="btn-submit" v-show="showloding">OK</button>
        </li>
      </ul>
    </div>
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
/*global mui*/
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
export default {
  data() {
    return {
      showloding: false,
      userInfo: this.util.user,
      currentTitle: "",
      fieldKey: "",
      fieldValue: "",
      password: "",
      password1: "",
      password2: "",
      fristtype: "password",
      fristtype1: "password",
      fristtype2: "password",
      fristeyepic: require("@/assets/images/icon/hide_eye_icon_251206.png"),
      fristeyepic1: require("@/assets/images/icon/hide_eye_icon_251206.png"),
      fristeyepic2: require("@/assets/images/icon/hide_eye_icon_251206.png"),
    };
  },
  methods: {
    fristeye() {
      if (this.fristtype == "password") {
        this.fristtype = "text";
        this.fristeyepic = require("@/assets/images/icon/show_eye_icon_251206.png");
      } else {
        this.fristtype = "password";
        this.fristeyepic = require("@/assets/images/icon/hide_eye_icon_251206.png");
      }
    },
    fristeye1() {
      if (this.fristtype1 == "password") {
        this.fristtype1 = "text";
        this.fristeyepic1 = require("@/assets/images/icon/show_eye_icon_251206.png");
      } else {
        this.fristtype1 = "password";
        this.fristeyepic1 = require("@/assets/images/icon/hide_eye_icon_251206.png");
      }
    },
    fristeye2() {
      if (this.fristtype2 == "password") {
        this.fristtype2 = "text";
        this.fristeyepic2 = require("@/assets/images/icon/show_eye_icon_251206.png");
      } else {
        this.fristtype2 = "password";
        this.fristeyepic2 = require("@/assets/images/icon/hide_eye_icon_251206.png");
      }
    },
    submitbtn() {
      if (!this.password) {
        mui.alert("The old login password cannot be empty");
      } else if (!this.password1) {
        mui.alert("New login password cannot be empty");
      } else if (this.password2 != this.password1) {
        mui.alert("Two new login passwords are inconsistent");
      } else if (!this.showloding) {
        this.savePasswd();
      }
    },
    submitbtn2() {
      if (!this.password && this.userInfo.has_pay_password == 1) {
        mui.alert("The old fund password cannot be empty");
      } else if (!this.password1) {
        mui.alert("New fund password cannot be empty");
      } else if (this.password2 != this.password1) {
        mui.alert("Two new fund passwords are inconsistent");
      } else if (!this.showloding) {
        this.savePasswd();
      }
    },
    savePasswd() {
      let params = { oldPassword: this.password, newPassword: this.password1 };
      this.util.setDnValueUser(params);
      let address = this.api.api_updateUserPassword;
      if (this.fieldKey == 'pay') address = this.api.api_updateUserPayPassword;
      this.axios.post(address, this.util.encodeSearchParams(params)).then(res => {
          this.showloding = false;
          if (res.data.code == 0) {
            if (this.fieldKey == 'pay') {
              this.userInfo.has_pay_password = 1;
              mui.toast("Fund password set successfully");
            }
            else mui.toast("Login password set successfully");
            window.history.back();
          } 
          else mui.toast(res.data.message);
        })
        .catch(() => {
          this.showloding = false;
          mui.toast("Modification failed");
        });
    },
  },
  activated() {
    if (!this.util.isLogin()) this.util.topage('login');
    this.password= "",
    this.password1= "",
    this.password2= "",
    this.fieldKey = this.$route.params.fieldKey;
    this.util.refreshUserInfo((res)=>{
      this.userInfo = res;
      this.fieldValue = this.userInfo[this.fieldKey];
      switch (this.fieldKey) {
        case "login": {
          this.currentTitle = "Change Login Password"
          break;
        }
        case "pay": {
          if (this.userInfo.has_pay_password == 1) this.currentTitle = "Change Fund Password"
          else this.currentTitle = "Fund Password Setting"
          break;
        }
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/login.scss";

.resister-content {
  font-size: 0.34rem;
  background: rgb(235, 235, 235);
  color: rgb(103, 103, 103);
  width: 100%;
  height: 100%;

  .box{
    font-size: 0.34rem;
  }
  .mine-header {
    color: black;
    font-weight: bold;
    height: 1.2rem;
    display: grid;
    grid-template-columns: 20% 1fr 20%;
    align-items: center;
    text-align: center;

    .back {
      cursor: pointer;
      img {
        display: block;
        margin-left: 5%;
        width: 0.5rem;
        transform: rotate(180deg);
      }
    }
  }
}
</style>  